import messagingService from "../api/messagingService";

export const makeCall = (groupId, body, groupName) => {
  return async (dispatch) => {
    let response = await messagingService.makeCall(groupId, body);
    if (response.status === 200) {
      dispatch({
        type: "MAKE_CALL",
        payload: {
          ...response.data,
          video: Boolean(body && body.video),
          screen: Boolean(body && body.screen),
        },
      });
    }
  };
};

export const answerCall = (groupId, roomId, peerId, video, screen = false) => {
  const isScreen = Boolean(screen);
  let body = {
    peerId,
    video: isScreen ? false : Boolean(video),
    screen: isScreen,
  };
  return async (dispatch) => {
    let response = await messagingService.answerCall(groupId, roomId, body);
    if (response.status === 200) {
      dispatch({
        type: "ANSWER_CALL",
        payload: {
          ...response.data,
          video: isScreen ? false : Boolean(response.data?.video ?? video),
          screen: Boolean(response.data?.screen || isScreen),
          // Ekran paylaşımını sadece arayan başlatır
          startScreenShare: false,
        },
      });
    }
  };
};

export const setCurrentCall = (call) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_CURRENT_CALL",
      payload: call,
    });
  };
};

export const setIncomingCall = (call) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_INCOMING_CALL",
      payload: call,
    });
  };
};

export const setOutgoingCall = (call) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_OUTGOING_CALL",
      payload: call,
    });
  };
};

export const rejectCall = (groupId, roomId, video) => {
  let body = { video };
  return async (dispatch) => {
    let response = await messagingService.rejectCall(groupId, roomId, body);
    if (response.status === 200) {
      dispatch({
        type: "REJECT_CALL",
        payload: response.data,
      });
    }
  };
};

export const endCall = (groupId, roomId) => {
  return async (dispatch) => {
    let response = await messagingService.endCall(groupId, roomId);
    if (response.status === 200) {
      dispatch({
        type: "END_CALL",
        payload: response.data,
      });
    }
  };
};

export const markBusyCall = (groupId, roomId, video) => {
  let body = {
    video,
  };
  return async (dispatch) => {
    let response = await messagingService.markBusyCall(groupId, roomId, body);
    if (response.status === 200) {
      dispatch({
        type: "MARK_BUSY_CALL",
        payload: response.data,
      });
    }
  };
};

export const markNoAnswerCall = (groupId, roomId, video) => {
  let body = {
    video,
  };
  return async (dispatch) => {
    let response = await messagingService.markNoAnswerCall(
      groupId,
      roomId,
      body
    );
    if (response.status === 200) {
      dispatch({
        type: "MARK_NO_ANSWER_CALL",
        payload: response.data,
      });
    }
  };
};

export const toggleDisplayMini = () => {
  return async (dispatch) => {
    dispatch({
      type: "TOGGLE_DISPLAY_MINI",
    });
  };
};

export const setDisplayMini = (displayMini) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_DISPLAY_MINI",
      payload: displayMini,
    });
  };
};
